module.exports = __webpack_public_path__ + "media/images/it/hero-home_mobile-15648cc46d069ddba1dbd55b2caa3835.jpg";